import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-isomasters-button',
  templateUrl: './isomasters-button.component.html',
  styleUrls: ['./isomasters-button.component.scss'],
})
export class IsomastersButtonComponent implements OnInit {
  @Input() selected = false;
  @Input() disabled = false;
  @Input() blockCheckMark = false;
  @Input() loading = false;
  @Output() modularClick = new EventEmitter<boolean>();

  constructor() {}

  get showCheckmark(): boolean {
    if (this.blockCheckMark) {
      return false;
    }
    return this.selected && !this.disabled;
  }

  ngOnInit() {}

  getClasses() {
    return {
      selected: this.selected && !this.disabled,
      disabled: this.disabled,
    };
  }

  clickButton(event) {
    if (this.selected || this.disabled) {
      return;
    }
    event.stopPropagation();
    this.emit();
  }

  private emit() {
    this.modularClick.emit(true);
  }
}
